import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@msc-b2c/shared-utils';
import VoyagersClubMembershipPointsRecap from './VoyagersClubMembershipPointsRecap';
import { RetrieveVoyagerClubInfoMembership } from '@msc-b2c/interfaces/interfaces';
import { VoyagerClubMembershipPointsRecapProps } from '@msc-b2c/interfaces/types';
export function VoyagersClubMembershipPointsRecapWrapper(
  props: Readonly<VoyagerClubMembershipPointsRecapProps>
) {
  const membershipData = useSelector((state: RootState) => state.myCruise.membershipData);

  const [membership, setMembership] = React.useState<RetrieveVoyagerClubInfoMembership>();

  useEffect(() => {
    setMembership(membershipData?.memberships[0] ?? membershipData?.memberships[0]);
  }, [membershipData]);

  // Merge Redux data with AEM props
  return (
    membership && (
      <VoyagersClubMembershipPointsRecap
        {...props}
        cruises={membership.cruises}
      />
    )
  );
}

VoyagersClubMembershipPointsRecapWrapper.aemResourceType =
  'b2c-website-foundation/components/mymsc/voyagersclubmembershippointsrecap';

export default VoyagersClubMembershipPointsRecapWrapper;
